module.exports = __webpack_public_path__ + "img/shape-13.fce259a1.png";